<template>
  <div class="add-domain">
    <add-domain />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import AddDomain from '@/components/dashboard/AddDomain'

export default {
  name: 'Dashboard',
  components: {
    AddDomain
  },
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>

<style lang="scss" scoped>
.add-domain { }
</style>
